import React from 'react';


export const Html = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/html.png')} />
    )
};
